module.exports = {
	"config": {
		"blogTitle": "Yvonne Zhang",
		"authorName": "Yvonne Zhang",
		"linkPrefix": "/",
		"avatar": "http://7xl4xb.com1.z0.glb.clouddn.com/IMG_5362.JPG",
		"logo": "http://7xl4xb.com1.z0.glb.clouddn.com/Artboard1.png",
		"favicon": "http://7xl4xb.com1.z0.glb.clouddn.com/Artboard1.png",
		"indexImage": "http://7xl4xb.com1.z0.glb.clouddn.com/scott-webb-195100.jpg",
		"google_analysis_id": "UA-80503375-1"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js"
			},
			"requirePath": "404.js",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "articles",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "articles",
				"stem": "index",
				"path": "articles/index.js"
			},
			"requirePath": "articles/index.js",
			"path": "/articles/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2013-12-06-css-position.md",
				"ext": "md",
				"name": "2013-12-06-css-position",
				"extname": ".md",
				"basename": "2013-12-06-css-position.md",
				"dirname": "blogs",
				"stem": "2013-12-06-css-position",
				"path": "blogs/2013-12-06-css-position.md"
			},
			"requirePath": "blogs/2013-12-06-css-position.md",
			"path": "/blogs/2013-12-06-css-position/",
			"data": {
				"title": "CSS Position 练习笔记",
				"date": "2013-12-06"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-02-html-semantics.md",
				"ext": "md",
				"name": "2014-04-02-html-semantics",
				"extname": ".md",
				"basename": "2014-04-02-html-semantics.md",
				"dirname": "blogs",
				"stem": "2014-04-02-html-semantics",
				"path": "blogs/2014-04-02-html-semantics.md"
			},
			"requirePath": "blogs/2014-04-02-html-semantics.md",
			"path": "/blogs/2014-04-02-html-semantics/",
			"data": {
				"title": "HTML5 Note #1：Let's Talk about Semantics",
				"date": "2014-04-02"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-03-html-header.md",
				"ext": "md",
				"name": "2014-04-03-html-header",
				"extname": ".md",
				"basename": "2014-04-03-html-header.md",
				"dirname": "blogs",
				"stem": "2014-04-03-html-header",
				"path": "blogs/2014-04-03-html-header.md"
			},
			"requirePath": "blogs/2014-04-03-html-header.md",
			"path": "/blogs/2014-04-03-html-header/",
			"data": {
				"title": "HTML5 Note #2 : The header element",
				"date": "2014-04-03"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-04-html-data.md",
				"ext": "md",
				"name": "2014-04-04-html-data",
				"extname": ".md",
				"basename": "2014-04-04-html-data.md",
				"dirname": "blogs",
				"stem": "2014-04-04-html-data",
				"path": "blogs/2014-04-04-html-data.md"
			},
			"requirePath": "blogs/2014-04-04-html-data.md",
			"path": "/blogs/2014-04-04-html-data/",
			"data": {
				"title": "HTML5 Note #3: HTML5 Custom Data Attributes (data-*)",
				"date": "2014-04-04"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-05-html-note4.md",
				"ext": "md",
				"name": "2014-04-05-html-note4",
				"extname": ".md",
				"basename": "2014-04-05-html-note4.md",
				"dirname": "blogs",
				"stem": "2014-04-05-html-note4",
				"path": "blogs/2014-04-05-html-note4.md"
			},
			"requirePath": "blogs/2014-04-05-html-note4.md",
			"path": "/blogs/2014-04-05-html-note4/",
			"data": {
				"title": "HTML5 Note #4: HTML5 Custom Data Attributes (data-*) [cont'd]",
				"date": "2014-04-05"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-07-http-note1.md",
				"ext": "md",
				"name": "2014-04-07-http-note1",
				"extname": ".md",
				"basename": "2014-04-07-http-note1.md",
				"dirname": "blogs",
				"stem": "2014-04-07-http-note1",
				"path": "blogs/2014-04-07-http-note1.md"
			},
			"requirePath": "blogs/2014-04-07-http-note1.md",
			"path": "/blogs/2014-04-07-http-note1/",
			"data": {
				"title": "HTTP Note #1: HTTP Basics",
				"date": "2014-04-07"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-20-http-note2.md",
				"ext": "md",
				"name": "2014-04-20-http-note2",
				"extname": ".md",
				"basename": "2014-04-20-http-note2.md",
				"dirname": "blogs",
				"stem": "2014-04-20-http-note2",
				"path": "blogs/2014-04-20-http-note2.md"
			},
			"requirePath": "blogs/2014-04-20-http-note2.md",
			"path": "/blogs/2014-04-20-http-note2/",
			"data": {
				"title": "HTTP Note #2: HTTP request message method",
				"date": "2014-04-20"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-04-28-http-note3.md",
				"ext": "md",
				"name": "2014-04-28-http-note3",
				"extname": ".md",
				"basename": "2014-04-28-http-note3.md",
				"dirname": "blogs",
				"stem": "2014-04-28-http-note3",
				"path": "blogs/2014-04-28-http-note3.md"
			},
			"requirePath": "blogs/2014-04-28-http-note3.md",
			"path": "/blogs/2014-04-28-http-note3/",
			"data": {
				"title": "HTTP Note #3: HTTP request message method (cont'd)",
				"date": "2014-04-28"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-05-26-express.md",
				"ext": "md",
				"name": "2014-05-26-express",
				"extname": ".md",
				"basename": "2014-05-26-express.md",
				"dirname": "blogs",
				"stem": "2014-05-26-express",
				"path": "blogs/2014-05-26-express.md"
			},
			"requirePath": "blogs/2014-05-26-express.md",
			"path": "/blogs/2014-05-26-express/",
			"data": {
				"title": "Node.js Note #1: Creating a basic site with Node.js and Express",
				"date": "2014-05-26"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2014-08-12-html-note5.md",
				"ext": "md",
				"name": "2014-08-12-html-note5",
				"extname": ".md",
				"basename": "2014-08-12-html-note5.md",
				"dirname": "blogs",
				"stem": "2014-08-12-html-note5",
				"path": "blogs/2014-08-12-html-note5.md"
			},
			"requirePath": "blogs/2014-08-12-html-note5.md",
			"path": "/blogs/2014-08-12-html-note5/",
			"data": {
				"title": "HTML5 Note #5: DOCTYPE And Browser Mode",
				"date": "2014-08-12"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2016-06-04-jsonp.md",
				"ext": "md",
				"name": "2016-06-04-jsonp",
				"extname": ".md",
				"basename": "2016-06-04-jsonp.md",
				"dirname": "blogs",
				"stem": "2016-06-04-jsonp",
				"path": "blogs/2016-06-04-jsonp.md"
			},
			"requirePath": "blogs/2016-06-04-jsonp.md",
			"path": "/blogs/2016-06-04-jsonp/",
			"data": {
				"title": "JSONP 如何解决跨域问题？",
				"date": "2016-06-04"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2016-06-21-generator.md",
				"ext": "md",
				"name": "2016-06-21-generator",
				"extname": ".md",
				"basename": "2016-06-21-generator.md",
				"dirname": "blogs",
				"stem": "2016-06-21-generator",
				"path": "blogs/2016-06-21-generator.md"
			},
			"requirePath": "blogs/2016-06-21-generator.md",
			"path": "/blogs/2016-06-21-generator/",
			"data": {
				"title": "Generator 函数初探",
				"date": "2016-06-21"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2017-12-17-object-prototype.md",
				"ext": "md",
				"name": "2017-12-17-object-prototype",
				"extname": ".md",
				"basename": "2017-12-17-object-prototype.md",
				"dirname": "blogs",
				"stem": "2017-12-17-object-prototype",
				"path": "blogs/2017-12-17-object-prototype.md"
			},
			"requirePath": "blogs/2017-12-17-object-prototype.md",
			"path": "/blogs/2017-12-17-object-prototype/",
			"data": {
				"title": "Object Prototype - Javascript Concepts You Should Know",
				"date": "2017-12-17"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs",
				"base": "2018-01-28-gamification.md",
				"ext": "md",
				"name": "2018-01-28-gamification",
				"extname": ".md",
				"basename": "2018-01-28-gamification.md",
				"dirname": "blogs",
				"stem": "2018-01-28-gamification",
				"path": "blogs/2018-01-28-gamification.md"
			},
			"requirePath": "blogs/2018-01-28-gamification.md",
			"path": "/blogs/2018-01-28-gamification/",
			"data": {
				"title": "产品游戏化初探",
				"date": "2018-01-28"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blogs/drafts",
				"base": "2017-11-04-write-my-own-js-promise.md",
				"ext": "md",
				"name": "2017-11-04-write-my-own-js-promise",
				"extname": ".md",
				"basename": "2017-11-04-write-my-own-js-promise.md",
				"dirname": "blogs/drafts",
				"stem": "2017-11-04-write-my-own-js-promise",
				"path": "blogs/drafts/2017-11-04-write-my-own-js-promise.md"
			},
			"requirePath": "blogs/drafts/2017-11-04-write-my-own-js-promise.md",
			"path": "/blogs/drafts/2017-11-04-write-my-own-js-promise/",
			"data": {
				"title": "Writing My Own Javascript Promise",
				"date": "2017-11-05"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "resume",
				"base": "ch.md",
				"ext": "md",
				"name": "ch",
				"extname": ".md",
				"basename": "ch.md",
				"dirname": "resume",
				"stem": "ch",
				"path": "resume/ch.md"
			},
			"requirePath": "resume/ch.md",
			"path": "/resume/ch/",
			"data": {
				"title": "简历",
				"layout": "resume"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "resume",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "resume",
				"stem": "index",
				"path": "resume/index.md"
			},
			"requirePath": "resume/index.md",
			"path": "/resume/",
			"data": {
				"title": "简历",
				"layout": "resume"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0